import noUiSlider from 'nouislider';
import 'nouislider/distribute/nouislider.css';
window.noUiSlider = noUiSlider;

$(document).ready(function () {

	$('div[data-id="form-input-range-slider"]').each((index, slider) => {
		let min		= $(slider).attr('min') || 0;
		let max		= $(slider).attr('max') || 100;
		let step	= $(slider).attr('step') || 1;
		let begin	= $(slider).attr('value') || $(slider).attr('begin') || 0;
		let end		= $(slider).attr('end') || null;

		let start = [parseInt(begin)];
		if (end !== null) {
			start = [parseInt(begin), parseInt(end)];
		}

		noUiSlider.create(slider, {
			start:		start,
			connect:	start.length > 1 ? [false, true, false] : [true, false],
			step:		parseInt(step),
			range: {
				'min': parseInt(min),
				'max': parseInt(max)
			}
		});

		$(slider).removeAttr('data-id');
	});
});
